import { IFeatureFlag } from ".";
import { URLs } from "../../commom/constant";
import ApplicationIdValues from "../../components/apiGateway/ApplicationIdValues";
import { ApiGateway } from "../../components/apiGateway/useApiGateway";

export const getFeatureFlags = (api: ApiGateway): Promise<IFeatureFlag> => {
    return api.get(`${URLs.paw_api_version}/applications/${URLs.paw_application_id}/featureflags`, ApplicationIdValues.AdminTool);
};